export function getPackageName(pack = {}) {
  return `${pack.display_name || pack.name}`.trim()
}

export function isStagedWithCortPackage(pack) {
  return getPackageName(pack).toLowerCase().includes('staged with cort')
}
